import { render, staticRenderFns } from "./DirectMembers.vue?vue&type=template&id=10f0b1ca&scoped=true"
import script from "./DirectMembers.vue?vue&type=script&lang=js"
export * from "./DirectMembers.vue?vue&type=script&lang=js"
import style0 from "./DirectMembers.vue?vue&type=style&index=0&id=10f0b1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0b1ca",
  null
  
)

export default component.exports